import { flagEnabled } from '../helpers/featureFlags';
import {
  getDismissedNbas,
  isNbaDismissed, MAX_NBAS, buildReturnStatusNba, dismissNbaCookie, buildEligibleDeviceSwapNba,
  canViewSwaps,
  buildOutageNba,
} from '../helpers/nba';
import { getConsolidatedOutageLob } from './consolidatedOutage';
import { getDeviceStatus } from './deviceStatus';
import { getHic } from './hic';
import { getItgRecommendations } from './itgRecommendations';
import { getOutage } from './outage';
import { loadReturns } from './returns';
import { getSwapEligibility } from './swapEligibility';

export const NBA_LOADING = 'NBA_LOADING';
export const SET_NBA_QUEUE = 'SET_NBA_QUEUE';
export const DISMISS_NBA = 'DISMISS_NBA';

const setNbaQueue = details => ({
  type: SET_NBA_QUEUE,
  payload: details,
});

const getOutageNba = (state, accountData, itgRecommendationsData) => {
  const isConsolidatedOutageLob = flagEnabled('enableOutageLob');
  const isUseSsmDeviceStatus = flagEnabled('useSsmDeviceStatus');

  const {
    consolidatedOutage: { data: consolidatedOutageData = null } = {},
    outage: { data: outageData = null } = {},
    deviceStatus: { data: ssmDeviceStatus = null } = {},
    hic: { data: hicData = null } = {},
  } = state;

  return buildOutageNba({
    outageData: isConsolidatedOutageLob ? consolidatedOutageData : outageData,
    deviceStatus: isUseSsmDeviceStatus ? ssmDeviceStatus : hicData,
    accountData,
    itgData: itgRecommendationsData,
  });
};


export const buildNbaQueue = () => async (dispatch, getState) => {
  dispatch({ type: NBA_LOADING });
  const { auth: { accountPerms = [] } = {}, account: { data: accountData = {} } = {} } = getState();
  const swapEnabled = flagEnabled('deviceSwapNba') && canViewSwaps(accountPerms, accountData);
  // Outage NBA only shows when Elevated Issue Detection is off (parity with deviceController)
  const eidEnabled = flagEnabled('enableElevatedIssueDetection');

  const nbaBuilders = [];
  if (!eidEnabled) {
    nbaBuilders.push(dispatch(getItgRecommendations()).catch(() => null));

    const outageRequest = flagEnabled('enableOutageLob')
      ? dispatch(getConsolidatedOutageLob())
      : dispatch(getOutage());
    const deviceStatusRequest = flagEnabled('useSsmDeviceStatus')
      ? dispatch(getDeviceStatus())
      : dispatch(getHic());

    nbaBuilders.push(outageRequest.catch(() => null));
    nbaBuilders.push(deviceStatusRequest.catch(() => null));
  }
  if (swapEnabled) {
    nbaBuilders.push(dispatch(getSwapEligibility()).catch(() => null));
  }
  nbaBuilders.push(dispatch(loadReturns()).catch(() => null));
  // Multiple asynchronous API calls will come here for NBA-related data
  await Promise.all(nbaBuilders);
  const state = getState();
  const {
    returns: { returns = [] } = {},
    swapEligibility: { data: swapData = {} } = {},
    itgRecommendations: { data: itgRecommendationsData = {} } = {},
  } = state;

  const dismissed = getDismissedNbas();

  const outageNba = !eidEnabled
    ? getOutageNba(state, accountData, itgRecommendationsData)
    : null;

  const nbaPaintPropBuilders = [];
  // Maintaining the order of how its seen on the screen.
  if (outageNba) nbaPaintPropBuilders.push(outageNba);
  nbaPaintPropBuilders.push(buildReturnStatusNba(returns));
  if (swapEnabled) {
    nbaPaintPropBuilders.push(buildEligibleDeviceSwapNba(swapData));
  }

  const details = nbaPaintPropBuilders
    .filter(Boolean)
    .filter(nba => !isNbaDismissed(nba.id, dismissed))
    .slice(0, MAX_NBAS);

  dispatch(setNbaQueue(details));
};

export const dismissNba = id => (dispatch) => {
  dismissNbaCookie(id);
  dispatch({ type: DISMISS_NBA, payload: id });
};
